import React from 'react'

export default function Summary (props) {
  return (
    <svg width='16px' height='16px' viewBox='0 0 16 16' {...props}>
      <path d='M8,0 C12.4,0 16,3.6 16,8 C16,12.4 12.4,16 8,16 C3.6,16 0,12.4 0,8 C0,3.6 3.6,0 8,0 Z M12.1,12.3 C13.3,11.2 14,9.7 14,8 C14,4.7 11.3,2 8,2 C4.7,2 2,4.7 2,8 C2,9.7 2.7,11.2 3.9,12.3 C4.3,11.6 5.1,11.3 6,11 C6.7,10.8 6.9,10.4 7,9.8 C5.8,9.4 5,8.3 5,7 C5,5.3 6.3,4 8,4 C9.700001,4 11,5.3 11,7 C11,8.3 10.1,9.4 9,9.8 C9.100001,10.4 9.3,10.8 10,11 C10.9,11.3 11.7,11.6 12.1,12.3 Z' fill='currentColor' />
    </svg>
  )
}



// WEBPACK FOOTER //
// ./components/Customers/icons/summary.js